// extracted by mini-css-extract-plugin
export var errorIcon = "_ko-1";
export var nameLogo = "_ko-0";